import { createMemoStyles } from '@wds/utils';
var useStyles = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing,
    palette = _ref.palette;
  return {
    infoMenu: {
      display: 'flex',
      '& > div > div > .wds-overlay': {
        top: spacing[7]
      }
    },
    descriptionBox: {
      whiteSpace: 'normal'
    },
    footnote: {
      padding: [spacing[1], spacing[5], spacing[6], spacing[5]],
      borderTop: [1, 'solid', palette.text.darkMuted],
      whiteSpace: 'normal'
    },
    helpIframe: {
      border: 'none'
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map